import React from 'react';
import PropTypes from 'prop-types';
import { I18n, windowPopUp } from '@deporvillage/utils-library-component';
import Picture from '@deporvillage/picture-component';

import styles from './GoogleSocialLogin.module.scss';

const Events = {
    GoogleSocialButtonLogin: 'google-social-button-login'
};

const GoogleSocialLogin = ({ onSocialLoginClick }) => {

    // istanbul ignore next
    const handleSocialLoginPopUp = (e) => {
        e.preventDefault();
        onSocialLoginClick && onSocialLoginClick(Events.GoogleSocialButtonLogin);
        const ref = windowPopUp(`/customer/social/google/sign-in`, '700', '500');
        const timer = setInterval(() => {
            if (ref.closed) {
                clearInterval(timer);
                window.location.reload();
            }
        }, 200);
    };

    return (
        <div className={styles['social-login']}>
            <button
                className={styles['google-social-button']}
                data-testid='google-social-button'
                onClick={handleSocialLoginPopUp}
            >
                <span className={styles['google-social-button-logo']}>
                    <Picture
                        src={'/static/icons/icon_google.png'}
                        height={25}
                        width={25}
                        transparent
                    />
                </span>{' '}
                <span className={styles['google-social-button-text']}>
                    <I18n>header.login_from.sign_in_google</I18n>
                </span>
            </button>
        </div>
    );
};

GoogleSocialLogin.propTypes = {
    onSocialLoginClick: PropTypes.func,
};

export default GoogleSocialLogin;
